import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useAlertsStore } from "./AlertsStore/alertsStore";
import { DialogActions, TextField } from "@mui/material";
import { OrangeTextButton } from "../../common/OrangeTextButton";

export const MuteAlertsDialog = ({
  selectedRow,
  navigate,
}: {
  selectedRow: any;
  navigate: any;
}) => {
  const { handleMuteAlerts, fetchSharedMutes, setMutedAlertInfo } =
    useAlertsStore();

  const { mutedAlertsDialogOpen, setMutedAlertsDialogOpen } = useAlertsStore();

  const [selectedMuteType, setSelectedMuteType] = React.useState("site");

  const [muteDuration, setMuteDuration] = React.useState(30);

  return (
    <Dialog
      open={mutedAlertsDialogOpen}
      maxWidth="xs"
      fullWidth={true}
      sx={{ height: 750 }}
    >
      <div className="pt-[5px]">
        <DialogContent>
          <Typography
            sx={{
              fontFamily: "Mulish",
              fontSize: 14,
              fontWeight: 700,
              color: "#d32f2f",
              pb: 2,
            }}
          >
            In addition to muting live alerts, muting also stops alert delivery
            to the monitoring center and third-party integrations (SMS, Immix,
            Milestone, webhooks) for the selected duration. This affects all
            operators — it does not just hide alerts from your view. Muted
            alerts are retained in your Resolved queue.
          </Typography>
          <FormControl>
            <RadioGroup value={selectedMuteType} name="radio-buttons-group">
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Radio
                  value="site"
                  onChange={(event) => {
                    setSelectedMuteType(event.target.value);
                  }}
                />
                <Typography sx={{ ml: 1, fontFamily: "Mulish" }}>
                  Mute All{" "}
                  <Typography
                    component="span"
                    sx={{ fontFamily: "Mulish", fontWeight: 900 }}
                  >
                    {selectedRow.display_name}
                  </Typography>{" "}
                  Site Alerts
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Radio
                  value="camera"
                  onChange={(event) => {
                    setSelectedMuteType(event.target.value);
                  }}
                />
                <Typography sx={{ ml: 1, fontFamily: "Mulish" }}>
                  Mute Only{" "}
                  <Typography
                    component="span"
                    sx={{ fontFamily: "Mulish", fontWeight: 900 }}
                  >
                    {selectedRow.camera_name}
                  </Typography>{" "}
                  Camera Alerts
                </Typography>
              </Box>
            </RadioGroup>
          </FormControl>
          <div className="pt-[30px] pl-[10px]">
            <Typography
              sx={{ fontFamily: "Mulish", fontSize: 16, fontWeight: 500 }}
            >
              Mute Duration (minutes)
            </Typography>
          </div>
          <div className="pt-[10px] pl-[10px]">
            <TextField
              value={muteDuration}
              onChange={(event) => {
                const value = event.target.value;
                // Only allow numbers (including empty string for clearing)
                if (value === "" || /^\d+$/.test(value)) {
                  setMuteDuration(value === "" ? 0 : Number(value));
                }
              }}
              onKeyDown={(event) => {
                // Prevent non-numeric characters from being typed
                if (
                  !/[0-9]/.test(event.key) &&
                  ![
                    "Backspace",
                    "Delete",
                    "Tab",
                    "Enter",
                    "ArrowLeft",
                    "ArrowRight",
                  ].includes(event.key)
                ) {
                  event.preventDefault();
                }
              }}
              sx={{ width: "100px" }}
              type="text"
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
          </div>
        </DialogContent>
      </div>
      <DialogActions>
        <OrangeTextButton
          text="Cancel"
          onClick={() => setMutedAlertsDialogOpen(false)}
          disabled={false}
        />
        <OrangeTextButton
          text="Save"
          onClick={async () => {
            // The operational mute endpoint takes a camera pk for both scopes;
            // the backend expands "site" scope to all of the site's cameras.
            const muteSucceeded = await handleMuteAlerts(
              selectedMuteType,
              "mute",
              selectedRow.camera_pk,
              muteDuration,
              navigate
            );
            // The muted lists are the shared fleet-wide state (ENG-2103):
            // refetch rather than appending locally.
            if (muteSucceeded) {
              fetchSharedMutes(navigate);
            }
            if (muteSucceeded && selectedMuteType === "site") {
              setMutedAlertInfo({
                siteName: selectedRow.display_name,
                cameraName: "",
                alertEndTime: Date.now() + muteDuration * 60 * 1000,
              });
            } else if (muteSucceeded) {
              setMutedAlertInfo({
                siteName: selectedRow.display_name,
                cameraName: selectedRow.camera_name,
                alertEndTime: Date.now() + muteDuration * 60 * 1000,
              });
            }

            // Auto-select first visible row after muting
            // Filter out the row that was just muted to get the correct first row
            // const filteredVisibleRows = visibleRows.filter((row: any) => {
            //   if (selectedMuteType === "site") {
            //     return row.customer_pk !== selectedRow.customer_pk;
            //   } else {
            //     return row.camera_pk !== selectedRow.camera_pk;
            //   }
            // });

            // if (visibleRows.length > 1) {
            //   const firstRow = visibleRows[1];
            //   handleRowSelected(
            //     firstRow,
            //     alertData,
            //     setAlertData,
            //     setSelectedButtonsFilled,
            //     setSeeMoreURL,
            //     navigate,
            //     setMP4URL,
            //     setVideoClipLoading,
            //     setSelectedRow,
            //     setSelectedAlertCameraInfo,
            //     setIgnoreZonesSelectedAlert,
            //     refreshingToken,
            //     visibleRows,
            //     setBackArrowDisabled,
            //     setForwardArrowDisabled,
            //     setShowRefreshButton
            //   );
            //   scrollToTop();
            // }

            setMutedAlertsDialogOpen(false);
          }}
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
